import { render, staticRenderFns } from "./InsightsCenterInsight.vue?vue&type=template&id=4256fcea&scoped=true"
import script from "./InsightsCenterInsight.vue?vue&type=script&lang=js"
export * from "./InsightsCenterInsight.vue?vue&type=script&lang=js"
import style0 from "./InsightsCenterInsight.vue?vue&type=style&index=0&id=4256fcea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4256fcea",
  null
  
)

export default component.exports